<template>
<div class="page page_zhibo">
    <!-- 热门视频 -->
    <div class="cn">
        <div class="cn_top">
            <div class="top_left">热门视频</div>
            <div class="top_right" @click="goMore('video')">更多</div>
        </div>
        <div class="cn_ul clearfix">
            <div class="cn_li f-l" v-for="living in dataList.video" :key="living.id" @click="goVideoDetail(living)">
                <div class="tu">
                    <img :src="living.thumb != null && living.thumb !='' ? imageUrl+living.thumb :''" alt="" class="">
                </div>
                <div class="info">
                    <div class="title slh_s">{{ living.title }}</div>
                </div>
            </div>
        </div>
    </div>
    <!-- 热门直播 -->
    <div class="cn zhibo">
        <div class="cn_top">
            <div class="top_left">热门直播</div>
            <div class="top_right" @click="goMore('live')">更多</div>
        </div>
        <div class="cn_ul">
            <!-- 循环体 -->
            <div class="cn_li" @click="goDetail(living.id)" v-for="living in dataList.room" :key="living.id">
                <div class="tu">
                    <img :src="living.thumb != null && living.thumb !='' ? imageUrl+living.thumb : ''" alt="" class="">
					<div class="tag">{{living.live_status_name}}</div>
                </div>
                <div class="info">
                    <div class="title">{{living.title}}</div>
                </div>
            </div>
        </div>
    </div>
    <!-- 直播回放 -->
    <!-- <div class="cn">
        <div class="cn_top">
            <div class="top_left">直播回放</div>
            <div class="top_right" @click="goMore('posvideo')">更多</div>
        </div>
        <div class="cn_ul clearfix">
            <div class="cn_li f-l" v-for="living in dataList.callback" :key="living.id" @click="goVideoDetail(living.id)">
                <div class="tu">
                    <img :src="living.thumb != null && living.thumb !='' ? ($publicData.domain + living.thumb):($publicData.imgPath+'statics/images/temp/tu01.png')" alt="" class="">
                </div>
                <div class="info">
                    <div class="title slh_s">{{ living.title }}</div>
                </div>
            </div>
        </div>
    </div> -->
    <!-- 精品推荐 -->
    <div class="cn tuijian">
        <div class="cn_top">
            <div class="top_left">精品推荐</div>
        </div>
        <div class="cn_ul">
            <div class="cn_li" v-for="posvideo in dataList.posvideo" :key="posvideo.id" @click="goVideoDetail(posvideo)">
                <div class="info">
                    <div class="info_t">
                        <div class="title slh">{{ posvideo.title }}</div>
                        <div class="desc slh video_describe" v-html="posvideo.describe.replace(/<[^>]*>/g,'')"></div>
                    </div>
                    <!-- <div class="price">
                        <span class="discount_price">¥80.00</span>
                        <span class="original_price">¥89.00</span>
                    </div> -->
                </div>
                <div class="tu">
                    <img :src="imageUrl+posvideo.thumb" alt="" class="">
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import PageSearch from "../../../component/search/Index.vue";
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            token: '',
			dataList: [],
            goNext: false,
			shareConfig: null // 分享的相关配置
        };
    },
    created: function () {
        console.log(this.$publicData.imgPath)
        var that = this
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    naviTitle: '视频直播',
                    'rightStyle': 'share'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
                var memberParams = {
                    data: {
                        'notCallLogin': 1,
                    },
                };
                this.$bridge.callhandler(
                    "sdjy://member/memberInfo",
                    memberParams,
                    (data) => {
                        if (data.code == 200) {
                            this.token = data.result.token;
                            
                        } else {
                            this.token = "";
                        }
                        this.getData()
                    }
                );
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
            //注册方法，右侧点击分享
            this.$bridge.registerhandler('sdjy://common/rightButtonAction', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                console.log('sdjy://common/rightButtonAction')
                const url = location.href.split('#')[0];
                var params = {
                    data: {
                        title: '视频直播 发现精彩',
                        detail: '更多精彩正在直播中，欢迎围观！\n点击这里，直达直播间！\n直播正在火热进行中！',
                        url: url,
                        platFormType:'',
                        image: that.$publicData.shareImgPath + 'shipin.jpg'
                    },
                };
                this.$bridge.callhandler('sdjy://public/share', params, (data) => {

                })

            })
        } else {
            this.token = this.$store.getters.token;
			// this.getData()
			// 调起 获取微信分享参数函数 -- 弃用,改成统一配置的
			this.getShareData()
        }
    },
    activated() {
		console.log('activated')
		if (this.goNext) {
			this.goNext = false
		} else {
			this.token = this.$store.getters.token
			this.dataList = []
			this.getData()
		}
	},
    methods: {
        // 获取数据
        getData() {
            this.$api.living.liveroomIndex().then(res => {
                if ( res.code == 200 ) {
					var list = res.result
					var room = list.room
					for(var i in room){
						var item = room[i]
						if(item.live_status == 0){
							item.live_status_name = '暂停'
						}else if(item.live_status == 1){
							var currentTime = new Date()
							var roomStartTime = new Date(item.open_room)
							var roomEndTime = new Date(item.close_room)
							if(currentTime < roomStartTime){
								item.live_status_name = '未开始'
							}else if(currentTime >= roomStartTime && currentTime <= roomEndTime ){
								item.live_status_name = '直播中'
							}else{
								item.live_status_name = '结束'
							}
						}else{
							item.live_status_name = '预告'
						}
					}
					this.dataList = list
                }
            })
        },
        // 去直播详情
		goDetail(id){
            var that = this
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': that.$publicData.clientUrl + '/zhibo/detail?id='+id
                    }
                }
                that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.goNext = true
                this.$router.push({
                    path: `/zhibo/detail`,
                    query:{id:id}
                })
            }
        },
        // 去视频详情
        goVideoDetail(item) {
            var that = this
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': that.$publicData.clientUrl + '/video/detail?id='+ item.id + '&is_charge='+ item.is_charge + '&prices=' + item.prices
                    }
                }
                that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.goNext = true
                this.$router.push({
                    path: `/video/detail`,
                    query: {
						id: item.id,
						is_charge: item.is_charge,
						prices: item.prices
                    }
                })
            }
            
        },
		// 获取分享参数 -- 用于配微信分享
        getShareData() {
			const url = location.href.split('#')[0];
			console.log('url', url)
            this.$api.index.commonShare({ url: url }).then(res => {
                if (res.code == 200) {
                    this.shareConfig = res.result
                    // console.log('this.shareConfig', this.shareConfig)
					// console.log('this.$route', this.$route)
					this.shareFun()
                }
            })
		},
		// 分享
        shareFun() {
			var that = this
            wx.config({
                debug: that.shareConfig.debug,
                beta: that.shareConfig.beta,
                jsApiList: that.shareConfig.jsApiList,
                appId: that.shareConfig.appId,
                nonceStr: that.shareConfig.nonceStr, // 随机串
                timestamp: parseInt(that.shareConfig.timestamp), // 时间戳
                signature: that.shareConfig.signature // 签名
			});
            // 分享
            wx.ready(function () {
				const url = location.href.split('#')[0];
				var shareData = {
					title: '视频直播 发现精彩', // 分享标题
					desc: '更多精彩正在直播中，欢迎围观！\n点击这里，直达直播间！\n直播正在火热进行中！', // 分享描述
					link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
					imgUrl: that.$publicData.shareImgPath + 'shipin.jpg', // 分享图标
					success: function () {
						// 用户确认分享后执行的回调函数
						// alert('成功')
					},
					cancel: function (e) {
						// alert(e)
						// 用户取消分享后执行的回调函数
					}
				}
                wx.updateAppMessageShareData(shareData);
                wx.updateTimelineShareData(shareData);
            });
        },
        // 更多
        goMore(type) {
            var that = this
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': that.$publicData.clientUrl + '/video/list/'+type
                    }
                }
                that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.goNext = true
                this.$router.push(`/video/list/${type}`)
            }
            
		},
		// 视频回放详情
		goPosVideoDetail(id) {
            var that = this
            if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                var params = {
                    'data': {
                        'url': that.$publicData.clientUrl + '/posvideo/detail?id=' + id
                    }
                }
                that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                })
            } else {
                this.goNext = true
                that.$router.push({
                    path: `/posvideo/detail`,
                    query: {
                        id: id
                    }
                })
			}   
			console.log('id',id) 
        },
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
</style>
